import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.showSystemMessage && _vm.canShow) || _vm.isPreviewActive)?_c('div',{attrs:{"id":"systemViewMessage","name":_vm.routeName}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.systemMessage)}}),_c(VIcon,{attrs:{"size":"12"},on:{"click":_vm.close}},[_vm._v("action_close")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }